export const uk = {
    found: 'Найдено',
    of: 'из',
    selected: 'Выбрано'
};
